import {
  DeleteTargetBadge,
  DeleteTargetBadgeVariables,
} from "_graphql/mutation/__generated__/deleteTargetBadge";

import { LocationGenerics } from "router/location";
import { PopUp } from "components";
import { deleteTargetBadge } from "../../_graphql/visal/mutations/target-badge";
import toast from "react-hot-toast";
import { useMutation } from "@apollo/client";
import { useSearch } from "react-location";
import { useTargetBadge } from "hooks/data/use-target-badge";

export default function RemoveTargetBadgeContainer({
  open,
  setOpen,
  refetch,
}: {
  open: boolean;
  setOpen: (val: boolean) => void;
  refetch?: () => void;
}) {
  const searchParams = useSearch<LocationGenerics>();
  const { loading, badge } = useTargetBadge({
    badgeId: searchParams?.id || "",
  });

  const [execute, { loading: deleting }] = useMutation<
    DeleteTargetBadge,
    DeleteTargetBadgeVariables
  >(deleteTargetBadge, {
    refetchQueries: ["fetchTarget"],
  });

  const handleSubmit = async () => {
    await execute({
      variables: {
        target_badge_id: searchParams?.id || "",
      },
    })
      .then(({ data }) => {
        if (data?.deleteTargetBadge) {
          toast.success("Badge deleted successfully");
          refetch?.();
          setOpen(false);
        } else {
          toast.error("Failed to delete badge");
        }
      })
      .catch((err) => {
        toast.error(err.message);
      });
  };

  return (
    <PopUp
      open={open}
      setOpen={setOpen}
      loading={loading}
      title="Delete Badge"
      cancelText="No, Don't Delete Badge"
      description={`Are you sure you want to delete the badge "${badge?.name}"? This will permanently delete this badge from the target. This action cannot be undone.`}
      renderActions={() => (
        <button
          type="button"
          disabled={deleting}
          className="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-red-600 text-base font-medium text-white hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 sm:ml-3 sm:w-auto sm:text-sm"
          onClick={handleSubmit}
        >
          {deleting ? "Deleting..." : "Delete Badge"}
        </button>
      )}
    />
  );
}
